module.exports = __webpack_public_path__ + "img/adoNet.4f7ba47a.svg";